import { AttachmentChip } from "./chips/attachment-chip";
import { SelectedElementChip } from "./chips/selected-element-chip";
import type { PromptAddon } from "@/stores/slices/prompt-context.slice";
import { PromptAddonType } from "@/stores/slices/prompt-context.slice";

export function ContextChips({ addons }: { addons: Array<PromptAddon> }) {
  return addons
    .filter((addon) => !addon.props.hidden)
    .map((addon) => {
      switch (addon.type) {
        case PromptAddonType.ATTACHMENT:
          return <AttachmentChip key={addon.id} addon={addon} />;
        case PromptAddonType.SELECTED_ELEMENT:
          return <SelectedElementChip key={addon.id} addon={addon} />;
        default:
          return null;
      }
    });
}
